<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M7.69 5.19L8.273 3h7.454l.583 2.19h5.28c1.056 0 1.91.872 1.91 1.95v11.812c0 1.075-.854 2.048-1.903 2.048H2.403C1.35 21 .5 20.127.5 19.049V7.238c0-1.078.854-1.952 1.91-1.952l5.28-.097z"/>
  <circle cx="12" cy="13" r="4" stroke="#000"/>
</svg>
